import { render } from "./calenderView.vue?vue&type=template&id=c36885fa"
import script from "./calenderView.vue?vue&type=script&lang=js"
export * from "./calenderView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__